// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__xP3RC"};